import { render, staticRenderFns } from "./VModalRules.vue?vue&type=template&id=0d7519cf&scoped=true&"
import script from "./VModalRules.vue?vue&type=script&lang=js&"
export * from "./VModalRules.vue?vue&type=script&lang=js&"
import style0 from "./VModalRules.vue?vue&type=style&index=0&id=0d7519cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7519cf",
  null
  
)

export default component.exports